
import { MutationsService } from '@vedicium/object-mutations';
import { ValidatorUtil } from '@vedicium/vue-core';
import Vue, { PropType } from 'vue';
import { APP_ERROR_EVENT } from '../../../../../constants';
import { Core } from '../../../../../services/core';

import { FilterPartEntity, FilterPartsStore } from '../../../../../services/parts';
import { PartsFiltersInformationForm } from '../components';

export default Vue.extend({
  name: 'partsFiltersViewInformation',
  props: {
    filter: {
      type: Object as PropType<FilterPartEntity>,
    },
  },
  data() {
    return {
      isLoadingForm: false,

      metadata: {
        filter: JSON.parse(JSON.stringify(this.filter)) as FilterPartEntity,
      },
    };
  },
  components: {
    PartsFiltersInformationForm,
  },

  methods: {
    async validate() {
      await ValidatorUtil.validateArray([(this.$refs.informationForm as Vue).$v]);
    },
    async onSubmit() {
      this.$set(this, 'isLoadingForm', true);
      try {
        await this.validate();

        const mutations = MutationsService.getMutationsByComparison(
          this.filter,
          this.metadata.filter,
          ['description', 'configuration_id'],
        );

        if (mutations.length > 0) {
          const entity = await FilterPartsStore.update(this.filter._meta.guid, mutations);

          this.$emit('update:filter', entity);
          this.$set(this.metadata, 'filter', JSON.parse(JSON.stringify(entity)));
        }

        this.$bvToast.toast('Document successfully updated', {
          title: 'Update successful',
          variant: 'success',
          solid: true,
        });
      } catch (e) {
        Core.Eventhub.emit(APP_ERROR_EVENT, e);
        console.error(e);
        return;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }
    },
  },
});
